export { ListItemIcon, ListItemIconProps } from './ListItemIcon';
